import { SectionHelper } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React from 'react';

import { NotificationWrapper } from '../../../help-center/components/NotificationWrapper';
import { RefreshNotificationDataHooks } from './RefreshNotification.dataHooks';

interface Props {
  hideRefreshNotification: Function;
}

export const RefreshNotification = (props: Props) => {
  const { hideRefreshNotification } = props;
  const { t } = useTranslation();

  const onRefreshSessionClick = () => {
    hideRefreshNotification();
  };

  return (
    <NotificationWrapper>
      <SectionHelper
        size="medium"
        actionText={t('inactive_modal_refresh_button')}
        onAction={onRefreshSessionClick}
        appearance="experimentalDark"
        showCloseButton={false}
        dataHook={RefreshNotificationDataHooks.refreshNotification()}
      >
        {t('inactive_modal_refresh_action_description')}
      </SectionHelper>
    </NotificationWrapper>
  );
};
